import moment from 'moment-timezone';
import first from 'lodash/first';
import last from 'lodash/last';

export function yearsTo(year) {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: year + 1 }, (value, index) => currentYear + index);
}

export function yearsFrom(year) {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - year + 1 }, (value, index) => year + index);
}

export function monthsOfYear() {
  return Array.from({ length: 12 }, (value, index) => 1 + index);
}

export function studentBirthYears(year) {
  const currentYear = new Date().getFullYear() - 2; // If this year is 2023, display backward from 2021 to {year}.
  return Array.from({ length: currentYear - year + 1 }, (value, index) => currentYear - index);
}

export function daysOfMonth(month, year) {
  if (!month || !year) {
    return [];
  }

  const daysInMonth = moment(`${month}-${year}`, 'MM-YYYY').daysInMonth();
  return Array.from({ length: daysInMonth }, (value, index) => index + 1);
}

export function currentDateJP() {
  return moment().format('YYYY年MM月DD日');
}

export function currentMonth() {
  return moment().format('YYYY/MM');
}

export function endOfCurrentMonth() {
  return moment().endOf('month').format('YYYY-MM-DD');
}

export function endOfCurrentMonthJP() {
  return moment().endOf('month').format('YYYY年MM月DD日');
}

export function startOfNextMonthJP() {
  return moment().add(1, 'months').startOf('month').format('YYYY年MM月DD日');
}

export function nextMonthJP() {
  return moment().add(1, 'months').format('YYYY年MM月');
}

export function nextNMonthJPs(numberOfMonths) {
  let arrayOfMonths = [];
  let nextMonths = nextNMonths(numberOfMonths);
  for (let index = 0; index < numberOfMonths; index++) {
    let monthElement = {
      value: nextMonths[index].toDate().getTime(),
      text: yearMonthJP(nextMonths[index].format('YYYY/MM')),
    };
    arrayOfMonths.push(monthElement);
  }
  return arrayOfMonths;
}

export function nextNMonths(numberOfMonths) {
  let arrayOfMonths = [];
  for (let index = 0; index < numberOfMonths; index++) {
    let timestamp = moment()
      .add(index + 1, 'months')
      .startOf('day')
      .startOf('month');
    arrayOfMonths.push(timestamp);
  }
  return arrayOfMonths;
}

export function currentMonthJP() {
  return {
    value: moment().toDate().getTime(),
    text: moment().format('YYYY年MM月'),
  };
}

export function previousNMonthJPs(numberOfMonths) {
  let arrayOfMonths = [];
  let previousMonths = previousNMonths(numberOfMonths);
  for (let index = 0; index < numberOfMonths; index++) {
    let monthElement = {
      value: previousMonths[index].toDate().getTime(),
      text: yearMonthJP(previousMonths[index].format('YYYY/MM')),
    };
    arrayOfMonths.push(monthElement);
  }
  return arrayOfMonths;
}

export function previousNMonths(numberOfMonths) {
  let arrayOfMonths = [];
  for (let index = 0; index < numberOfMonths; index++) {
    let timestamp = moment()
      .subtract(index + 1, 'months')
      .startOf('day');
    arrayOfMonths.push(timestamp);
  }
  return arrayOfMonths;
}

export function yearMonthJP(yearSlashMonth) {
  let yearMonthArray = yearSlashMonth.split('/');
  let year = first(yearMonthArray);
  let month = last(yearMonthArray);
  return year + '年' + month + '月';
}

export function dateDiff(date1, date2) {
  if (date1 && date2) {
    return moment(date2).diff(moment(date1), 'days');
  }
  return 0;
}

export function reformatDatetimeToMonthJP(datetime) {
  if (datetime) {
    datetime = {
      value: datetime,
      text: moment(datetime).format('YYYY年MM月'),
    };
  }
  return datetime;
}
